import { Icon } from "@iconify/react";
import React from "react";
import Slider from "react-slick";
import Div from "../Div";
import Timeline from "../Timeline";

const timelineData = [
  [
    {
      year: "Mobile",
      name: "Mobile App Development",
      position: "Built with Flutter & React Native",
      type: "Cross-platform excellence",
    },
    {
      year: "Web",
      name: "Web Applications",
      position: "Developed using Spring Boot, .NET & Laravel",
      type: "Enterprise-grade solutions",
    },
  ],
  [
    {
      year: "Website",
      name: "Website Development",
      position: "Crafted with React & Next.js",
      type: "Modern & responsive design",
    },
    {
      year: "DevOps",
      name: "Cloud & DevOps",
      position: "Deployed on AWS, Docker & Kubernetes",
      type: "Scalable infrastructure",
    },
  ],
  [
    {
      year: "AI",
      name: "AI & Data Science",
      position: "Implemented with TensorFlow, OpenAI & PyTorch",
      type: "Intelligent solutions",
    },
    {
      year: "Backend",
      name: "Backend & Databases",
      position: "Powered by Node.js, Django, PostgreSQL & MongoDB",
      type: "High-performance architecture",
    },
  ],
];

export default function TimelineSlider() {
  /** Slider Settings **/
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    arrows: false,
    responsive: [
      {
        breakpoint: 470,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings} className="cs-arrow_style3">
      {timelineData.map((item, index) => (
        <Div key={index}>
          <Timeline columnData={item} />
        </Div>
      ))}
    </Slider>
  );
}
